var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCorDoGrao = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 5.5625L15.7732 9.33583C17.8532 11.4158 17.8532 14.7958 15.7732 16.8758C14.7332 17.9158 13.3665 18.4358 11.9998 18.4358C10.6332 18.4358 9.2665 17.9158 8.2265 16.8758C6.1465 14.7958 6.1465 11.4158 8.2265 9.33583L11.9998 5.5625ZM9.17317 15.9346C9.9265 16.6946 10.9332 17.1079 11.9998 17.1079V7.44792L9.17317 10.2813C8.41317 11.0346 7.99984 12.0412 7.99984 13.1079C7.99984 14.1746 8.41317 15.1746 9.17317 15.9346Z",
    fill: "#696F88"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCorDoGrao);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Cor_do_Grao.6790d1d34258a696db82c12fef9a57cf.svg";